export enum SpotWageRateType {
  NoRate = 0,
  EmployeeRate = 1,
  Incremental = 2,
  SpotRate = 3
}

export const SpotWageRateTypeMapping: Record<SpotWageRateType, string> = {
  [SpotWageRateType.NoRate]: 'No Rate',
  [SpotWageRateType.EmployeeRate]: 'Employee',
  [SpotWageRateType.Incremental]: 'Incremental',
  [SpotWageRateType.SpotRate]: 'Spot Rate'
};
